import React, { useEffect, useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { useLocation, useNavigate } from "react-router-dom";
import { VscHome } from "react-icons/vsc";
import { HiLockClosed, HiOutlineRectangleGroup } from "react-icons/hi2";
import { BsGear } from "react-icons/bs";
import { BiLock, BiSupport, BiUser } from "react-icons/bi";
import { HiLogout } from "react-icons/hi";
import Spinner from "../../Components/Spinner";
import { FiAlertTriangle, FiLock } from "react-icons/fi";
import { RiKey2Line, RiSecurePaymentLine } from "react-icons/ri";
import { TbUsersGroup } from "react-icons/tb";

function AdminSidebar({ onNavigate, userData, statusRefresh, isSidebarClosed }) {
    const { t } = useLanguage();
    const navigate = useNavigate()
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('');
    const [expandedSection, setExpandedSection] = useState('');
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const currentPath = location.pathname;

        // Set expandedSection if needed (you can keep your current logic or adjust similarly)
        // if (currentPath.includes("llm_new_chat")) {
        //     setExpandedSection("llm-chat");
        // } else if (currentPath.includes("spaces")) {
        //     setExpandedSection("instances");
        // } else if (currentPath.includes("cloud_storage") || currentPath.includes("deleted_files")) {
        //     setExpandedSection("cloud_storage");
        // } else {
        //     const pathName = currentPath.split('/').pop();
        //     setExpandedSection(pathName);
        // }

        // Active link logic: match if pathname includes the link
        const links = ['projects', 'billing', 'support', 'profile', 'logout', 'settings', 'api'];
        const matchedLink = links.find(link => currentPath.includes(link));
        if (matchedLink) {
            setActiveLink(matchedLink);
        }

    }, [location.pathname]);


    const handleLinkClick = (link) => {
        setActiveLink(link);
        onNavigate(link);
    };

    const getLinkStyle = (link) => {
        return activeLink === link ? ({ color: "var(--mainColor)" }) : {};
    };



    const handleLogout = () => {
        setLoading(true);
        sessionStorage.removeItem("user_id");
        document.cookie = "erioon=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        setTimeout(() => {
            navigate(`/login`);
        }, 700);
    };

    return (
        <div className={`sidebar_cont fade-in ${isSidebarClosed ? "closed_sidebar" : ""}`}>
            {isSidebarClosed ? (

                <>
                    <div className="sidebar_body">
                        <div className="sidebar_body_main">

                            <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('projects')} style={getLinkStyle('projects')}>
                                    <i><HiOutlineRectangleGroup /></i>
                                </p>
                            </div>
                            {/* <div className="link_container">
                                <p className="side_link side_link_locked" onClick={() => handleLinkClick('alerts')} style={getLinkStyle('alerts')}>
                                    <i><FiAlertTriangle /></i>
                                    <span className="locked_section_link"><HiLockClosed /></span>
                                </p>
                            </div>

                            <div className="link_container">
                                <p className="side_link side_link_locked" onClick={() => handleLinkClick('settings')} style={getLinkStyle('settings')}>
                                    <i><BsGear /></i>

                                    <span className="locked_section_link"><HiLockClosed /></span>
                                </p>
                            </div> */}
                            <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('api')} style={getLinkStyle('api')}>
                                    <i><RiKey2Line /></i>
                                </p>
                            </div>

                            <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('billing')} style={getLinkStyle('billing')}>
                                    <i><RiSecurePaymentLine /></i>
                                </p>
                            </div>

                            <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('support')} style={getLinkStyle('support')}>
                                    <i><BiSupport /></i>
                                </p>
                            </div>

                        </div>
                        <div className="link_container">
                            <p className="side_link" onClick={() => onNavigate('settings')} style={getLinkStyle('settings')}>
                                <i><BsGear /></i>
                            </p>
                        </div>

                        <div className="link_container">
                            <p className="side_link" onClick={() => onNavigate('profile')} style={getLinkStyle('profile')}>
                                <i><BiUser /></i>
                            </p>
                        </div>

                        <div className="link_container">
                            <p className="side_link logout_side_link" onClick={handleLogout} style={getLinkStyle('logout')}>
                                {loading ? (
                                    <div className="side_link_spinner_cont">
                                        <Spinner loading={true} err={({ message: "", display: "none" })} />
                                    </div>
                                ) : (
                                    <i><HiLogout /></i>
                                )}
                            </p>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="sidebar_body">
                        <div className="sidebar_body_main">

                            <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('projects')} style={getLinkStyle('projects')}>
                                    <i><HiOutlineRectangleGroup /></i> {t.sidebar.projects}
                                </p>
                            </div>
                            {/* <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('teams')} style={getLinkStyle('teams')}>
                                    <i><TbUsersGroup /></i> Teams
                                </p>
                            </div> */}
                            {/* <div className="link_container">
                                <p className="side_link side_link_locked" onClick={() => handleLinkClick('alerts')} style={getLinkStyle('alerts')}>
                                    <i><FiAlertTriangle /></i> {t.sidebar.alerts}
                                    <span className="locked_section_link"><HiLockClosed /></span>
                                </p>
                            </div>

                            <div className="link_container">
                                <p className="side_link side_link_locked" onClick={() => handleLinkClick('settings')} style={getLinkStyle('settings')}>
                                    <i><BsGear /></i> {t.sidebar.settings}
                                    <span className="locked_section_link"><HiLockClosed /></span>
                                </p>
                            </div> */}

 <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('api')} style={getLinkStyle('api')}>
                                    <i><RiKey2Line /></i> {t.sidebar.api}
                                </p>
                            </div>
                            <div className="link_container">
                                <p className="side_link " onClick={() => handleLinkClick('billing')} style={getLinkStyle('billing')}>
                                    <i><RiSecurePaymentLine /></i> {t.sidebar.billing}
                                </p>
                            </div>

                            <div className="link_container">
                                <p className="side_link" onClick={() => handleLinkClick('support')} style={getLinkStyle('support')}>
                                    <i><BiSupport /></i> {t.sidebar.support}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="sidebar_footer">
                        <div className="settings_center">
                            <p className="settings_link" onClick={() => onNavigate('settings')} style={getLinkStyle('settings')}><i><BsGear /></i> {t.sidebar.settings}</p>

                            <p className="settings_link" onClick={() => onNavigate('profile')} style={getLinkStyle('profile')}><i><BiUser /></i> {t.sidebar.profile}</p>
                            <div className="settings_link last_link" onClick={handleLogout}>
                                <p><i><HiLogout /></i> {t.sidebar.logout}</p>
                            </div>
                            {loading ? (
                                <div className="settings_link_info">
                                    <Spinner loading={true} err={({ message: "", display: "none" })} />
                                </div>
                            ) : (
                                userData && (
                                    <div className="settings_link_info" onClick={() => onNavigate('profile')}>
                                        <p className="logout_from_account">{userData.personal_info.name} {userData.personal_info.surname}</p>
                                        <p className="logout_from_account">
                                            {userData.user_type.charAt(0).toUpperCase() + userData.user_type.slice(1)}
                                        </p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </>

            )}
        </div>
    );
}

export default AdminSidebar;
